import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';

export default class FaseFenologicaValidation extends DefaultValidation {
	validate(model, refs) {
		let validated = true;

        if(refs.idagrofasefenologicaerpInput.required && Util.isNull(model.idagrofasefenologicaerp)) {
			refs.idagrofasefenologicaerpInput.focusedOut = true;
			validated = false;
		}

		if (Util.isNull(model.descricao)) {
			refs.descricaoInput.focusedOut = true;
			validated = false;
		}
        

    return validated;
  }
}